<div class="Dialog Dialog--version">
  <mat-toolbar color="primary" class="Dialog__header">
    <h2 class="Dialog__title" mat-dialog-title><mat-icon>update</mat-icon> Ny uppdatering tillgänglig!</h2>
  </mat-toolbar>
  <div class="Dialog__content" mat-dialog-content>
    <p class="mat-caption">
      Vi jobbar kontinuerligt med nya uppdateringar i systemet.<br />
      Det innebär ibland att du som användare behöver ladda om sidan och/eller logga ut och in igen.<br />
      Om du är mitt uppe i något så är det helt ok att stänga ner den här rutan nu och göra detta senare, dock kan vi inte garantera att
      systemet fungerar till 100% innan uppdateringen görs.
    </p>
    <p class="mat-subtitle-2">
      Den här uppdateringen kräver en omladdning av sidan{{ REQUIRES_SIGNIN ? ' samt att du loggar ut och in igen.' : '.' }}<br />
      Vi hjälper dig med detta så det enda du behöver göra är att klicka på Uppdatera-knappen här nedan och luta dig tillbaka.
    </p>
    <p class="mat-headline-6 flex items-center justify-start gap-2">
      <mat-icon>code</mat-icon> <span>v{{ data.version.version }}-{{ data.version.commitShort }}</span>
    </p>
  </div>
  <div class="Dialog__actions" mat-dialog-actions>
    <span class="flex-1"></span>
    <button type="button" mat-button (click)="dialogRef.close()">Senare</button>
    <button type="button" mat-raised-button color="primary" (click)="dialogRef.close(true)"><mat-icon>update</mat-icon> Uppdatera</button>
  </div>
</div>
